/**
 * 集中管理所有业务状态/类型的颜色和文本映射
 */

import { COLORS } from './colors';

export interface StatusConfig {
  color: string;
  text: string;
}

/** 活动状态映射 */
export const CAMPAIGN_STATUS_MAP: Record<string, StatusConfig> = {
  draft: { color: 'default', text: '草稿' },
  ready: { color: 'blue', text: '就绪' },
  sending: { color: 'orange', text: '发送中' },
  paused: { color: 'gold', text: '已暂停' },
  completed: { color: 'green', text: '已完成' },
};

/** 消息状态映射 */
export const MESSAGE_STATUS_MAP: Record<string, StatusConfig> = {
  draft: { color: 'default', text: '草稿' },
  generating: { color: 'processing', text: '生成中' },
  ready: { color: 'blue', text: '就绪' },
  queued: { color: 'cyan', text: '排队中' },
  sent: { color: 'geekblue', text: '已发送' },
  delivered: { color: 'green', text: '已送达' },
  read: { color: 'lime', text: '已读' },
  failed: { color: 'red', text: '失败' },
};

/** 发送任务状态映射 */
export const SEND_TASK_STATUS_MAP: Record<string, StatusConfig> = {
  queued: { color: 'cyan', text: '排队中' },
  scheduled: { color: 'blue', text: '已定时' },
  sending: { color: 'processing', text: '发送中' },
  sent: { color: 'geekblue', text: '已发送' },
  delivered: { color: 'green', text: '已送达' },
  read: { color: 'lime', text: '已读' },
  failed: { color: 'red', text: '失败' },
};

/** 回复意向映射 */
export const INTENT_MAP: Record<string, StatusConfig> = {
  positive: { color: 'green', text: '积极' },
  neutral: { color: 'default', text: '中性' },
  negative: { color: 'red', text: '消极' },
  follow_up: { color: 'orange', text: '待跟进' },
};

/** 洞察状态映射 */
export const INSIGHT_STATUS_MAP: Record<string, StatusConfig> = {
  analyzing: { color: 'processing', text: '分析中' },
  completed: { color: 'success', text: '已完成' },
  failed: { color: 'error', text: '失败' },
};

/** 通知优先级映射 */
export const PRIORITY_MAP: Record<string, string> = {
  low: 'default',
  normal: 'blue',
  high: 'red',
};

/** 知识库条目类型映射 */
export const ENTRY_TYPE_MAP: Record<string, StatusConfig> = {
  cooperation: { color: 'blue', text: '合作记录' },
  pricing: { color: 'green', text: '报价基准' },
  template: { color: 'purple', text: '提案模板' },
  client_preference: { color: 'orange', text: '客户偏好' },
  influencer_tag: { color: 'cyan', text: '红人标签' },
};

/** 置信度等级映射 */
export interface ConfidenceConfig {
  color: string;
  text: string;
  tagColor: string;
}
export const CONFIDENCE_MAP: Record<string, ConfidenceConfig> = {
  high: { color: COLORS.success, text: '高', tagColor: 'success' },
  medium: { color: COLORS.warning, text: '中', tagColor: 'warning' },
  low: { color: COLORS.error, text: '低', tagColor: 'error' },
};
